module.exports = __webpack_public_path__ + "static/img/16.3b42bb7d.png";